export const labels = {
  title: 'Title',
  message: 'Message',
  recipient: 'Recipient',
  type: 'Type',
  file: 'File',
  sender: 'Sender name',
  sendername: 'Sender name',
  allowSending: 'Allow sending type',
  text: 'Text',
  image: 'Image URL',
  images: 'Images',
  hash: 'Hash',
  service: 'Service',
  provider: 'Provider',
  defaultRoute: 'Default route',
  ip: 'IP',
  hostname: 'Hostname',
  headers: 'Headers',
  body: 'Body',
  params: 'Parameters',
  request: 'Request',
  response: 'Response',
  server: 'Server',
  method: 'Method',
  uri: 'Uri',
  statusCode: 'Status code',
  preset: 'Preset',
  encoding: 'Encoding',
  asOwner: 'On behalf of the owner of the message',
  template: 'Template',
  id: 'ID',
  chainId: 'Chain ID',
  groupId: 'Group ID',
  owner: 'Owner',
  Owner: 'Owner',
  OwnerId: 'Owner',
  TariffId: 'Tariff',
  dursec: 'Call (total)',
  billsec: 'Call (billing)',
  pattern: 'Pattern',
  status: 'Status',
  date: 'Date',
  time: 'Time',
  source: 'Source',
  amount: 'Amount',
  target: 'no targets | one target | {count} targets',
  direction: 'Direction',
  protocol: 'Protocol',

  button: {
    subheader: 'Button',
    url: 'Button URL',
    text: 'Button text',
    action: 'Button action'
  },

  targets: {
    include: 'Phone numbers to include (with + prefix)',
    exclude: 'Phone numbers to exclude (with + prefix)',
    info: 'Choose contact lists or type in phone numbers with + prefix (up to 100 numbers)'
  },

  schedule: {
    delay: 'Date and time',
    until: 'Stretch the mailing'
  },

  $options: {
    onStatus: 'On status',
    onTimeout: 'On timeout',
    onIncomingPayload: 'On incoming payload'
  },

  options: {
    status: 'Previous message received status',
    timeout: 'Time passed',
    except: 'And previous message status is not equal',
    onIncomingPayload: {
      text: 'If the text of the incoming message is'
    }
  },

  payload: {
    sender: 'Sender',
    recipient: 'Recipient',
    text: 'Text',
    image: 'Image',
    file: 'File',
    tts: 'TTS',
    button: {
      text: 'Button text',
      action: 'Button action',
      url: 'Button URL'
    }
  },

  state: {
    detailed: {
      ids: 'Detailed IDs'
    },
    status: 'Status'
  },

  meta: {
    _recipientData: 'Operator',
    _routing: {
      provider: 'Provider'
    },
    billing: {
      id: 'Billing ID',
      amount: 'Amount'
    },
    billings: {
      ids: 'Billing ID'
    },
    stats: {
      segments: 'Segments',
      characters: 'Characters'
    },
    replacement: {
      payload: {
        sender: 'Sender replacement',
        text: 'Text replacement'
      }
    },
    patternId: 'Template for moderation'
  },

  data: {
    price: 'Price',
    multiplier: 'Multiplier'
  },

  external: {
    id: 'External ID'
  }
}

export default {
  title: 'Detailed report',

  sending: 'Sending',
  sendings: 'Sendings',
  new: 'New sending',
  noData: 'No sendings found',
  targets: 'Targets',
  messages: 'Messages',
  preview: 'Preview',
  create: 'Create new sending',
  type: 'Sending type',
  uploadImageText: 'Drag an image here<br>or<br>click to choose file',
  getImageKey: 'Get image key',
  count: 'no new sendings | one new sending | {count} new sendings',
  insert: 'Insert',

  labels,

  headers: {
    status: 'Status',
    owner: 'Owner',
    provider: 'Provider',
    type: 'Type',
    recipient: 'Recipient',
    sender: 'Sender',
    text: 'Text',
    amount: 'Amount',
    operator: 'Operator',
    count_sent: 'In&nbsp;progress',
    count_delivered: 'Delivered',
    percent_delivered: 'Percent delivered',
    count_seen: 'Seen',
    count_failed: 'Failed',
    count_total: 'Total',
    opgroup: 'Operator&nbsp;group',
    operatorGroup: 'Operator group',
    mcc: 'mcc',
    mnc: 'mnc',
    sending: 'Message to',
    fallback: 'Fallback to',
    tariff: 'Tariff',
    from: 'From',
    billing_tariff_price: 'Price',
    billing_sum_all: 'Sum&nbsp;of&nbsp;all',
    billing_sum_pending_complete: 'Sum completed',
    billing_sum_refunded_invalid: 'Sum refunded',
    updatedAt: 'Updated at',
    createdAt: 'Created at'
  },

  titles: {
    preview: 'Preview',
    filter: 'Filter',
    schedule: 'Start of mailing',
    sudoData: 'Data',
    resend: 'Resend',
    incoming: {
      details: 'Incoming messages'
    },
    replacement: {
      original: 'Original',
      rule: 'By rule',
      provider: 'By provider'
    }
  },

  filter: {
    attributes: 'Attributes',
    id: 'ID',
    groupId: 'Group ID',
    chainId: 'Chain ID',
    title: 'Filter',
    status: 'Status',
    type: 'Type',
    OwnerId: 'Owner',
    from: 'From',
    pattern: 'Pattern',
    payload: {
      recipient: 'Recipient',
      sender: 'Sender name'
    },
    meta: {
      _routing: {
        provider: 'Provider'
      },
      user: {
        id: 'Owner'
      }
    },
    state: {
      status: 'Status'
    },
    date: {
      from: 'Date from',
      by: 'Date by'
    },
    time: {
      from: 'Time from',
      by: 'Time by'
    },
    clear: 'Clear filter'
  },

  hints: {
    date: {
      from: 'YYYY-MM-DD',
      by: 'YYYY-MM-DD'
    },
    time: {
      from: 'HH:MM',
      by: 'HH:MM'
    },
    button: {
      url: 'Max 2048 symbols, example: http://www.example.com',
      text: 'Max 30 symbols'
    },
    text: 'View full text of message',
    empty: 'To get data use the filter.',
    remoteReport: 'Your report has been sent to the email you specified during registration.',
    sale: 'Sale',
    purchase: 'Purchase',
    has: {
      replacement: 'Has replacement'
    },
    resend: 'By default, the message will be sent on behalf of the current user.',
    apisender: 'Found instance bound to sendername:',
    replacement: {
      original: 'Original message payload',
      rule: 'Message rules replacement results',
      provider: 'Message payload sent to provider'
    }
  },

  presets: {
    sendings: {
      details: 'Sendings details',
      group001: 'Group by sending type',
      group002: 'Group by operator group and provider',
      group003: 'Dashboard report'
    }
  },

  statistic: {
    title: 'Statistic',
    symbols: 'Symbols: {count}',
    parts: 'Parts: {count}',
    segments: 'Segments: {count}'
  },

  statuses: {
    pending: 'Pending',
    paused: 'Paused',
    processing: 'Processing',
    sent: 'Sent',
    delivered: 'Delivered',
    seen: 'Seen',
    failed: 'Failed'
  },

  report: {
    download: 'Download',
    get: 'Get report'
  },

  attributes: {
    id: 'ID',
    chainId: 'Chain ID',
    type: 'Type',
    userId: 'User',
    providerId: 'Provider',
    operatorCode: 'Operator code',
    operatorGroup: 'Operator group',
    text: 'Text',
    sender: 'Sender',
    recipient: 'Recipient',
    error: 'Error',
    status: 'Status'
  },

  status: {
    succeed: 'Succeed',
    failed: 'Failed',
    pending: 'Pending',
    processing: 'Processing',
    queued: 'Queued',
    paused: 'Paused',
    sent: 'Sent',
    processed: 'Processed',
    delivered: 'Delivered',
    seen: 'Seen'
  },

  subheaders: {
    scheduling: 'Scheduling',
    options: 'Resend conditions',
    resend: 'Send this message only if:'
  },

  confirm: {
    send: {
      title: 'You are about to send ',
      count: 'no message | one message | {count} messages',
      text: 'Be sure to check recipient, sender, text and other info before continuing.',
      loading: 'We are preparing to send your messages. This may take a minute.'
    }
  },

  tooltips: {
    preview: 'Message preview is now available in the “Message Preview” tab',
    count: '{count} messages',
    save: 'Save as template',
    planning: 'Planning',
    insert: 'Insert variable',
    billing_sum_pending_complete: 'Sum of pending and completed',
    billing_sum_refunded_invalid: 'Sum of refunded and invalid',
    refresh: 'Refresh table data using the selected filter.',
    segments: 'Characters | Segments | Seconds (optional)',
    billSec: 'Tariff seconds',
    approve: 'Approve',
    reject: 'Reject',
    moderation: 'Moderation',
    replacement: 'Has replacement',
    fallbacks: 'Has fallbacks ({count})',
    price: 'Price per message',
    reset: 'Reset all filled fields and start over',
    validation: 'Not filled',
    title: 'View availability conditions for "Campaign name"',

    tasks: {
      filter: {
        owner: 'Go to the outgoing tab and add the owner of the current task to the filter'
      }
    },

    insertVariables: 'Insert variables',
    goTo: 'Go to {service}'
  },

  filterMenu: {
    any: 'Any data',
    string: 'Russian characters without spaces',
    phone: 'Phone number',
    email: 'E-mail',
    date: 'Date dd.mm.yy'
  },

  catchSymbolsMenu: {
    symbols: 'Symbols',
    numbers: 'Numbers',
    symbolsNumbers: 'Symbols or numbers',
    symbolsNumbersSpaces: 'Symbols, numbers or spaces',
    russianSymbols: 'Russian symbols',
    russianSymbolsNumber: 'Russian symbols or numbers',
    russianSymbolsNumbersSpaces: 'Russian symbols, numbers or spaces'
  },

  tabs: {
    format: 'Format',
    source: 'Source',
    create: 'New message',
    templates: 'Templates',
    sendings: 'Sendings',
    outgoing: 'Outgoing',
    incoming: 'Incoming',
    tasks: 'Tasks',
    logs: 'Logs',
    routing: 'Routes',
    billings: 'Price',
    fallbacks: 'Fallbacks',
    replacement: 'Replacement',
    sendingsModeration: 'Moderation',
    eventsHistory: 'History of changes'
  },

  fallbacks: {
    sentStatus: {
      sent: 'Sent',
      notSent: 'Not sent'
    }
  },

  contents: {
    noAllowedSendingTypes: 'Currently you cannot send any types of messages.<br>Please contact administrator to set up your account.',
    noPattern: 'Pattern not found',
    confirm: {
      resend: 'Confirm message resending.'
    }
  },

  errors: {
    payload: {
      button: {
        url: 'The url field fails to match the required pattern!'
      }
    },
    recipients: {
      include: 'Recipients is required'
    },
    button: {
      url: 'Character limit exceeded',
      text: 'Character limit exceeded'
    },
    no: {
      sendernames: 'There are no approved and connected sender names for sending messages. You can request new sender names in the <strong>"Sender names"</strong> section.'
    }
  },

  schedule: {
    types: {
      now: 'Now',
      latter: 'Later'
    },

    until: {
      0: 'Don\'t stretch',
      1: 'Stretch for 1 hour',
      2: 'Stretch for 2 hours',
      3: 'Stretch for 3 hours',
      4: 'Stretch for 4 hours',
      5: 'Stretch for 5 hours',
      6: 'Stretch for 6 hours',
      7: 'Stretch for 7 hours',
      8: 'Stretch for 8 hours',
      9: 'Stretch for 9 hours',
      10: 'Stretch for 10 hours',
      11: 'Stretch for 11 hours',
      12: 'Stretch for 12 hours'
    },

    no: {
      date: 'Date and time not selected'
    }
  },

  buttons: {
    refresh: 'Refresh'
  },

  snackbars: {
    created: 'Sending successfully created.',
    updated: 'Sending successfully updated.',
    removed: 'Sending successfully removed.'
  },

  infos: {
    title: 'The field <strong>"Campaign name"</strong> is available for filling in if one or more of the following conditions are met:</br>- start of the mailing is delayed,</br>- if the "Sending addresses" field contains more than 100 numbers,</br>- if the "Sending addresses" field contains contacts or contact groups from the "Contacts" section,</br>- if the "Exclusion addresses" field is filled in'
  },

  warnings: {

    fallbacks: {
      validation: 'None of the resend parameters are filled.'
    },

    tts: 'Too many generation attempts. Try again in <strong>{cooldown}</strong> sec.',

    own: 'To send a test SMS without moderation, <strong>do not change it</strong>!<br><br>To send messages with any text, contact your manager or technical support.',
    imlink: 'Dear Customer,<br>To send test message, please contact your AM <strong><a href="mailto:sale@imlink.io">sale@imlink.io</a></strong> or Support Team <strong><a href="mailto:support@imlink.io">support@imlink.io</a></strong>'
  }
}
